export default {
  // 邊類型描述
  expandEdge: "這是擴展邊",
  addressOwnership: "這是地址歸屬",
  sameIpAccount: "同ip賬號",
  sameDeviceAccount: "同設備賬號",

  // 字段標簽
  sender: "發送方：",
  receiver: "接收方：",
  currencyName: "幣種名稱：",
  totalQuantity: "總數量：",
  transactionHash: "交易哈希：",
  transactionTime: "交易時間：",
  transactionQuantity: "交易數量：",
  total: "總數：",
  averageQuantity: "平均數量：",

  // 範圍連接詞
  to: "至",
};
